import { Add, CheckCircle, Edit, List } from '@mui/icons-material';
import { alpha, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceAddressActionEnum } from 'src/shared/models/enums/invoiceAdressAction.enum';

interface InvoiceActionTypeItem {
  name: string;
  description: string;
  actionType: InvoiceAddressActionEnum;
  icon: JSX.Element;
}

const actionTypeArray: InvoiceActionTypeItem[] = [
  {
    name: 'invoice:invoiceAddressType.createNew',
    description: 'invoice:invoiceAddressType.createNewInfo',
    actionType: InvoiceAddressActionEnum.CreateNew,
    icon: <Add className='icon' />,
  },
  {
    name: 'invoice:invoiceAddressType.chooseFromReg',
    description: 'invoice:invoiceAddressType.chooseFromRegInfo',
    actionType: InvoiceAddressActionEnum.FromRegister,
    icon: <List className='icon' />,
  },
  {
    name: 'invoice:invoiceAddressType.editExisting',
    description: 'invoice:invoiceAddressType.editExistingInfo',
    actionType: InvoiceAddressActionEnum.EditExisting,
    icon: <Edit className='icon' />,
  },
];

type InvoiceAddressActionSelectorProps = {
  selectedActionType: number | undefined;
  setSelectedActionType: React.Dispatch<React.SetStateAction<number | undefined>>;
  invoiceAddressId: number | undefined;
};

export const InvoiceAddressActionSelector = (props: InvoiceAddressActionSelectorProps) => {
  const { selectedActionType, setSelectedActionType, invoiceAddressId } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          {!selectedActionType &&
            actionTypeArray.map((exp) => (
              <Grid item xs={12} md={4} key={exp.actionType}>
                <Button
                  color='primary'
                  variant='outlined'
                  disabled={exp.actionType === InvoiceAddressActionEnum.EditExisting && !invoiceAddressId}
                  fullWidth
                  className={selectedActionType === exp.actionType ? 'selected' : ''}
                  sx={{
                    py: 3,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    height: '100%',
                    backgroundColor: '#fff',
                    position: 'relative',
                    '&:hover': {
                      backgroundColor: (theme) => alpha(theme.palette.success.light, 0.2),
                    },
                    '&.selected': {
                      borderWidth: 3,
                      backgroundColor: (theme) => alpha(theme.palette.success.light, 0.2),
                    },
                    '& .icon': {
                      width: '2rem',
                      height: '2rem',
                      opacity: 0.8,
                      mb: 1,
                    },
                  }}
                  onClick={() => setSelectedActionType(exp.actionType)}
                >
                  {exp.icon}
                  <Typography variant='body1' component='div' sx={{ fontWeight: 400, display: 'flex', alignItems: 'center', mb: 1 }}>
                    {t(exp.name)}
                    {selectedActionType === exp.actionType && (
                      <CheckCircle sx={{ width: '1.5rem', height: '1.5rem', opacity: 1, ml: 1, color: (thm) => thm.palette.success.main }} />
                    )}
                  </Typography>
                  <Typography variant='body2' component='div' sx={{ fontWeight: 100, display: 'flex', alignItems: 'center', textTransform: 'none' }}>
                    {t(exp.description)}
                  </Typography>
                </Button>
              </Grid>
            ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
